import React, {useContext} from 'react';
import {useTranslation} from '../../../context/language';
import {theme} from '../../../styles/darkTheme';
import {
  AmountContainer,
  Button,
  ButtonTitle,
  Cancel,
  Container,
  DateContainer,
  Id,
  InfoContainer,
  LabelDay,
  LabelMonth,
  Name,
  RemittanceContainer,
  Amount,
  Received,
  Pending,
} from './styles';
import {TabSwitchContext} from '../../../context/tabSwtich';
import {useDispatch, useSelector} from 'react-redux';
import {
  SET_REMITTANCE,
  SET_REMITTANCE_RESPONSE,
} from '../../../redux/actionTypes';
import store from '../../../redux/store';
import {parsePhoneNumber} from 'libphonenumber-js';
import {useNavigate} from 'react-router-dom';
import {RootState} from '../../../redux/reducers';

interface Props {
  data: {
    firstName?: string;
    lastName?: string;
    valueSize?: string;
    clear?: boolean;
    day?: string;
    month?: string;
    stage?: string;
    id: string;
    currency?: string;
    amount?: string;
    description?: string;
    entireData?: any;
    codeRemittance?: string;
  };
}

const HistoryCard: React.FC<Props> = ({data}) => {
  const {text} = useTranslation();
  const {currentWatchChannel} = useSelector((state: RootState) => ({
    ...state.channel,
  }));
  const {chatRoom, user} = store.getState();
  const history = useNavigate();

  const {setTabSwitch} = useContext(TabSwitchContext);
  const {
    firstName,
    lastName,
    valueSize,
    clear,
    day,
    month,
    stage,
    id,
    currency,
    amount,
    description,
    entireData,
    codeRemittance,
  } = data;
  const dispatch = useDispatch();

  const getUserData = () => {
    const members = currentWatchChannel?.members;
    if (!members) return;
    for (let i = 0; i < members?.length || 0; i++) {
      const curr = members[i];
      if (curr.user_id !== user.id) {
        return curr.user;
      }
    }
    return null;
  };

  const handleClick = () => {
    const userData = getUserData();
    const {country, countryCallingCode, nationalNumber} = parsePhoneNumber(
      //@ts-ignore
      String(userData.phoneNumber),
    );
    const info = {
      name: `${firstName || ''} ${lastName || ''}`,
      description: description,
      amount: amount,
      mobilePhone: nationalNumber,
      countryCode: countryCallingCode,
      currency: currency,
      emojiURL: `https://flag.pk/flags/4x3/${String(country)}.svg`,
      codeRemittance: codeRemittance,
    };
    dispatch({type: SET_REMITTANCE, payload: info});
    history('/confirm');
  };

  const handleGoToDetails = () => {

    const country = parsePhoneNumber(`${String(entireData.sender.completePhoneNumber)}`,).country;
    const info = {
      id: id,
      action: entireData.action === 'send' ? 'remittance' : 'request_remittance',
      name: `${firstName || ''} ${lastName || ''}`,
      description: description,
      amount: amount,
      mobilePhone: entireData.sender.phoneNumber,
      countryCode: entireData.sender.dialCountryCode.slice(1, -1),
      currency: currency,
      emojiURL: `https://flag.pk/flags/4x3/${String(country)}.svg`,
    };
    dispatch({type: SET_REMITTANCE, payload: info});
    dispatch({type: SET_REMITTANCE_RESPONSE, payload: entireData});
    history('/details');
  };

  return (
    <Container theme={theme} clear={clear}>
      <DateContainer>
        <LabelDay theme={theme}>{day}</LabelDay>
        <LabelMonth theme={theme}>{month}</LabelMonth>
      </DateContainer>
      <RemittanceContainer>
        <InfoContainer onClick={handleGoToDetails}>
          <Name theme={theme} valueSize={valueSize}>
            {firstName} {lastName}
          </Name>
          {stage == text.canceled ? (
            <Cancel theme={theme} valueSize={valueSize}>
              {stage}
            </Cancel>
          ) : null}
          {entireData.action === 'send' ? (
            <Received theme={theme} valueSize={valueSize}>
              {text.received}
            </Received>
          ) : null}
          {entireData.action === 'request' ? (
            <Pending theme={theme} valueSize={valueSize}>
              {text.requested}
            </Pending>
          ) : null}
          <Id theme={theme} valueSize={valueSize}>
            {text.id}
            {id.substring(4)}
          </Id>
        </InfoContainer>
        <AmountContainer>
          <Amount theme={theme} valueSize={valueSize}>
            {parseFloat(amount || '').toFixed(2)}
            {currency}
          </Amount>
          {entireData.action !== 'send' ? (
            <Button theme={theme} onClick={handleClick}>
              <ButtonTitle theme={theme}>{text.repeatRequest}</ButtonTitle>
            </Button>
          ) : null}
        </AmountContainer>
      </RemittanceContainer>
    </Container>
  );
};

export default HistoryCard;
